module.exports = __webpack_public_path__ + "static/homepage-news-33d7504b3ae47e4f4f07a25d72786979.png";